import React, { FC } from 'react';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { GreenTickWithCircleIcon } from 'assets/icons';
import {
  LEGAL_REACCEPTANCE_SUCCESS_BODY,
  LEGAL_REACCEPTANCE_SUCCESS_CTA,
  LEGAL_REACCEPTANCE_SUCCESS_TITLE,
  LEGAL_REACCEPTANCE_SUCCESS_WHATS_NEXT_BODY,
  LEGAL_REACCEPTANCE_SUCCESS_WHATS_NEXT_TITLE
} from 'containers/legal-reacceptance/constants';

export interface LegalReacceptanceSuccessScreenProps {
  onBackToApp: () => void;
}

const LegalReacceptanceSuccessScreen: FC<LegalReacceptanceSuccessScreenProps> = ({ onBackToApp }) => {
  const handleBackToAppClick = () => {
    onBackToApp();
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col p-8 pb-10">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-6 text-center">
        <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-[#e8f7ef]">
          <GreenTickWithCircleIcon className="h-12 w-12" aria-hidden />
        </div>
        <div className="flex max-w-md flex-col gap-2">
          <h2 className="text-xl font-semibold text-primaryText">{LEGAL_REACCEPTANCE_SUCCESS_TITLE}</h2>
          <p className="text-sbase font-semibold text-primaryText">{LEGAL_REACCEPTANCE_SUCCESS_BODY}</p>
        </div>
        <div className="w-full max-w-md rounded-lg border border-borderGray bg-[#f0f6ff] p-4 text-left">
          <p className="text-sbase font-semibold text-secondary">{LEGAL_REACCEPTANCE_SUCCESS_WHATS_NEXT_TITLE}</p>
          <p className="mt-1 text-sbase font-semibold text-primaryText">{LEGAL_REACCEPTANCE_SUCCESS_WHATS_NEXT_BODY}</p>
        </div>
      </div>
      <div className="shrink-0 pt-4">
        <CustomButton
          type={ButtonType.PRIMARY}
          onClick={handleBackToAppClick}
          id="legal-reacceptance-success-done-btn"
          className="h-12 w-full"
          childrenContainerStyles="text-17px font-semibold">
          {LEGAL_REACCEPTANCE_SUCCESS_CTA}
        </CustomButton>
      </div>
    </div>
  );
};

export default LegalReacceptanceSuccessScreen;
